package com.qrkontaq.pages

import androidx.compose.runtime.Composable
import com.qrkontaq.ui.landing.LegalPage
import com.qrkontaq.ui.landing.PRIVACY_DOC
import com.qrkontaq.ui.landing.REFUND_DOC
import com.qrkontaq.ui.landing.TERMS_DOC
import com.varabyte.kobweb.core.Page

@Page("/terms")
@Composable
fun TermsPage() = LegalPage(TERMS_DOC)

@Page("/privacy")
@Composable
fun PrivacyPage() = LegalPage(PRIVACY_DOC)

@Page("/refund")
@Composable
fun RefundPage() = LegalPage(REFUND_DOC)
